import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO23 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK002-3.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO23
